import { APP_ZONES } from '@finxone-platform/shared/sys-config-types';
import jwt_decode from 'jwt-decode';
import { formatNameAsUrl } from './zone-url.utils';

export const unauthenticatedRoutes = [
  `/zones/${formatNameAsUrl(APP_ZONES.ONBOARDING)}`,
  `/zones/${formatNameAsUrl(APP_ZONES.ORGANISATION_ONBOARDING)}`,
  `/zones/${formatNameAsUrl(APP_ZONES.SIGNED_OUT_FIRST_INTRODUCTION)}`,
  `/zones/${formatNameAsUrl(APP_ZONES.SIGNED_OUT_INTRODUCTION)}`,
  `/zones/${formatNameAsUrl(APP_ZONES.SIGNED_OUT_FORGOT_PASSWORD)}`,
  `/feature-redirect`,
  `/invitations`,
  '/organisation-onboarding-completion/',
];

export function isAuthenticatedRoute(route: string) {
  if (unauthenticatedRoutes.some((unauthenticatedRoute) => route.includes(unauthenticatedRoute))) {
    return false;
  } else {
    return true;
  }
}

export function checkTokensInStorageOrWindow(): boolean {
  if (sessionStorage.getItem('refreshToken') && sessionStorage.getItem('token')) {
    return true;
  }
  if ((window as any).accessToken && (window as any).refreshToken) {
    return true;
  }
  return false;
}

export function getTokenFromStorageOrWindow(): string | null {
  return (sessionStorage.getItem('token') as string) || (window as any).accessToken || null;
}

export function isTokenExpired(token: string): boolean {
  const jwtToken: Record<string, string | number> = jwt_decode(token);
  const currentTimestamp = Math.floor(Date.now() / 1000);
  const isExpired = Number(jwtToken?.['exp']) < currentTimestamp;
  return isExpired;
}
